<template>
    <DForm
        @submit.prevent="submitForm"
    >
        <DCol
            sm="12"
            class="pb-3"
        >
            <DFormRow
                :label="__('settings.lov_termination_reasons.form.name_en')"
                :is-required="true"
                :error="errors.name_en"
                :hint="__('settings.lov_termination_reasons.form.name_en_hint')"
            >
                <DInput
                    id="name_en"
                    v-model="form.name_en"
                    :placeholder="__('settings.lov_termination_reasons.form.name_en')"
                    :is-valid="isFormFieldValid('name_en')"
                    maxlength="255"
                />
            </DFormRow>
        </DCol>
        <DCol
            sm="12"
            class="pb-3"
        >
            <DFormRow
                :label="__('settings.lov_termination_reasons.form.name_de')"
                :is-required="false"
                :error="errors.name_de"
                :hint="__('settings.lov_termination_reasons.form.name_de_hint')"
            >
                <DInput
                    id="name_de"
                    v-model="form.name_de"
                    :placeholder="__('settings.lov_termination_reasons.form.name_de')"
                    :is-valid="isFormFieldValid('name_de')"
                    maxlength="255"
                />
            </DFormRow>
        </DCol>
        <DCol
            sm="12"
            class="pb-3"
        >
            <DFormRow
                :label="__('settings.lov_termination_reasons.form.short_name')"
                :is-required="true"
                :error="errors.short_name"
                :hint="__('settings.lov_termination_reasons.form.short_name_hint')"
            >
                <DInput
                    id="short_name"
                    v-model="form.short_name"
                    :placeholder="__('settings.lov_termination_reasons.form.short_name')"
                    :is-valid="isFormFieldValid('short_name')"
                    :disabled="canEditShortName === false"
                    maxlength="255"
                />
            </DFormRow>
        </DCol>
        <DCol
            sm="12"
            class="pb-3"
        >
            <DFormRow
                :label="__('settings.lov_termination_reasons.form.list_order')"
                :is-required="false"
                :error="errors.list_order"
                :hint="__('settings.lov_termination_reasons.form.list_order_hint')"
            >
                <DInput
                    id="list_order"
                    v-model="form.list_order"
                    :placeholder="__('settings.lov_termination_reasons.form.list_order')"
                    :is-valid="isFormFieldValid('list_order')"
                    maxlength="255"
                />
            </DFormRow>
        </DCol>
        <DFormControls
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
    terminationReason: {
        type: Object,
        default () {
            return {}
        }
    },
    canEditShortName: {
        type: Boolean,
        default () {
            return true
        }
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const emit = defineEmits(['form-submitted'])

const form = useForm({
    id: props.terminationReason.id ?? null,
    name_en: props.terminationReason.name_en ?? null,
    name_de: props.terminationReason.name_de ?? null,
    short_name: props.terminationReason.short_name ?? null,
    list_order: props.terminationReason.list_order ?? null
})

const submitForm = () => {
    emit('form-submitted', form)
}

</script>

<style lang="scss">

</style>
